import * as React from 'react';
import { faMinus } from '@fortawesome/free-solid-svg-icons';

import CircleButton from './CircleButton';

const MinusButton = ({ onClick, disabled }: { onClick: (e: any) => void; disabled: boolean }) => (
  <CircleButton onClick={onClick} icon={faMinus} disabled={disabled} />
);

export default MinusButton;
